// removed by extract-text-webpack-plugin
module.exports = {"item-icon":"_1jHkLeUcFHJD01J2P73Q0s","rotated":"_2UG2Efrlmu26nXQazwRhwq","dropdown-container":"_2sKmIs88VqxRlfRYnMtWDy","dropdown-menu":"_1hx8ZS0W9VA1lydYpJBWJ1","dropdown-header":"_3y_-3-u7WAbfp0lPuIkajs","dropdown-icon":"_3d18WOMKPnZw-Yea8Vag9U","dropdown-list":"_3-dqggJVkV5XjxU-n0udnb","group":"_11YhO_kQOkykfKBxIhDYo2","group-header":"_2omqRFC1VdHo7-qdyyK6JZ","dropdown-item":"RyguQR6iYKEWmXcXuHJF2","icon":"_2_AtJWx1nJekQp7Sqm3zn6","label":"_3W0dIXvkr0M7GLsiAf1jzF","shown":"_3TaSbaah9A5U6eBQW7QkpU","spin":"JGt87Ipops1OhCg7QdXUb"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Action/DropdownMenu/styles.scss
// module id = 170
// module chunks = 18